@import '../../shared';

.button {
  position: relative;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  justify-content: center;
  padding: 1.2rem 1.5rem;
  border-radius: $border-radius-small;
  outline: none;
  font-family: $font-stack;
  font-size: $font-size-default;
  font-weight: bold;
  letter-spacing: $letter-spacing-medium;
  line-height: $line-height-large;
  background-color: $header-background;
  color: $white;
  
  &:hover {
    cursor: pointer;
    background-color: $dark-purple;
  }

  &:active {
    background-color: $blue;
  }

  &:focus,
  &:focus-visible {
    box-shadow: 0 0 0 0.125rem $green;
  }

  &.--inverted {
    background-color: $white;
    border: 0.0625rem solid $header-background;
    color: $header-background;

    .button__icon {
      fill: $blue;
    }

    .loading-spinner {
      border-color: transparent $blue-border $blue-border $blue-border;
    }

    &:hover {
      border-color: transparent;
      box-shadow: 0 0.4375rem 0.625rem 0 rgba(108, 130, 209, 0.5);
    }

    &:active {
      color: $white;
      background-color: $blue;
    }

    &:focus {
      border-color: transparent;
    }
  }
}

.button--disabled,
.button--disabled.form-stepper__button {
  background-color: $reference-card-border;
  color: #fff;
  pointer-events: none;
  &:hover {
    cursor: auto;
  }
}

.button--disabled.--inverted {
  background-color: #fff;
  border-color: $reference-card-border;
  color: $reference-card-border;
  pointer-events: none;
  &:hover {
    cursor: auto;
  }
  .button__icon {
    fill: $reference-card-border;
  }

  .loading-spinner {
    border-color: transparent $reference-card-border $reference-card-border
      $reference-card-border;
  }
}

.button--basic {
  border: 0;
  color: $header-text-color;
  padding: 0;
}

.button__icon {
  fill: $header-text-color;
}

.button--link {
  padding: 0;
  background: transparent;
  letter-spacing: inherit;
  border-radius: 0;
  border-width: 0;
  outline: none;
  text-transform: none;
  vertical-align: inherit;
}

.graph-button {
  width: 8rem;
  min-height: 3.6rem;
  font-size: $font-size-default;
  padding: 0.4rem;
  letter-spacing: $letter-spacing-normal;

  @media (min-width: $breakpoint-md) {
    width: 10rem;
  }

  &.button--red-inverted {
    border-color: $red-text;
    color: $red-text;
  }

  &.button--blue-inverted {
    border-color: $blue-text;
    color: $blue-text;
  }

  &.button--green-inverted {
    border-color: $green-text;
    color: $green-text;
  }

  &.graph-button--inactive {
    border-color: $yellow-background;
  }
}

.borderless-button {
  border: none !important;
  letter-spacing: $letter-spacing-normal;
  font-size: $font-size-default;

  &:active {
    background: #fff;
  }

  &:focus {
    box-shadow: none;
  }
}

.button--loading {
  color: transparent;
}

.profile-option__edit-button {
  min-width: unset;
  min-height: unset;
}

// Button in header
.activity-tracker__container > button {
  min-width: unset;
  min-height: unset;
  padding: 0;

  &:hover {
    cursor: pointer;
    background-color: $header-background;
  }

  &:active {
    background-color: $header-background;
  }

  &:focus {
    box-shadow: unset;
    text-shadow: 0 0 0.4rem $blue-border;
  }
}
